import {
  CACHE_PATIENT,
  CACHE_PORTAL_INVITES,
  CACHE_PORTAL_RELATION_STATUSES,
  CACHE_PORTAL_THREAD_MESSAGES,
  CACHE_PORTAL_THREADS,
  SET_CLIENTS_CACHED,
  SET_ORGANIZATIONS_CACHED,
} from './actionTypes';

export const setOrganizationsCached = (isCached) => ({
  type: SET_ORGANIZATIONS_CACHED,
  payload: { isCached },
});

export const setClientsCached = (isCached) => ({
  type: SET_CLIENTS_CACHED,
  payload: { isCached },
});

export const cachePatient = (patientId, tab) => ({
  type: CACHE_PATIENT,
  payload: { patientId, tab },
});

export const cachePortalInvites = (portalPatientId, invites) => ({
  type: CACHE_PORTAL_INVITES,
  payload: { portalPatientId, invites },
});

export const cachePortalRelationStatuses = (portalPatientId, relationStatuses) => ({
  type: CACHE_PORTAL_RELATION_STATUSES,
  payload: { portalPatientId, relationStatuses },
});

export const cachePortalThreads = (patientId, threads) => ({
  type: CACHE_PORTAL_THREADS,
  payload: { patientId, threads },
});

export const cachePortalThreadMessages = (threadId, messages) => ({
  type: CACHE_PORTAL_THREAD_MESSAGES,
  payload: { threadId, messages },
});
